$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  if (p === "organizer_booking_table" && a === "list") {
    $(document).on("click", ".booking-table-delete-button", function () {
      let bookingTableId = $(this).attr("data-booking-table-id");
      let locationId = $("body").attr("event_id");
      let confirmMessage = $(this).attr("data-delete-message");
      if (!confirm(confirmMessage)) {
        return false;
      }
      if (
        parseInt($(this).attr("data-number-of-booking-area-table-is-active")) >
        0
      ) {
        return false;
      }

      $.ajax({
        type: "POST",
        url: "/ajax/organizer_booking_table/delete",
        data: {
          booking_table_id: bookingTableId,
          location_id: locationId,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("#booking-table-list-sortable").empty();
            $("#booking-table-list-sortable").append(data.html);
            popupAlert();
          }

          if (
            data.has_deactivated_booking_tables !== undefined &&
            data.has_deactivated_booking_tables !== null &&
            data.has_deactivated_booking_tables == true
          ) {
            $("#show-deactivated-booking-table-button").removeClass("d-none");
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
  }

  if (p === "organizer_booking_table" && a === "show") {
    $("select[name=booking_area_id]").select2({
      theme: "bootstrap4",
    });

    $(document).on("click", "#booking-area-table-register-button", function () {
      let tableId = $(this).attr("data-booking-table-id");
      let bookingAreaId = $(
        "select[name='booking_area_id'] option:selected",
      ).val();
      let locationId = $("body").attr("event_id");

      $.ajax({
        type: "POST",
        url: "/ajax/organizer_booking_area_table/new",
        data: {
          booking_area_id: bookingAreaId,
          table_id: tableId,
          location_id: locationId,
          add_area: true,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("select[name='booking_area_id'] option:selected").remove();
            $("#booking-area-table-list-wrapper").empty();
            $("#booking-area-table-list-wrapper").append(data.html);
            popupAlert();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on("click", ".booking-area-delete-button", function () {
      let tableId = $(this).attr("data-table-id");
      let bookingAreaTableId = $(this).attr("data-booking-area-table-id");
      let locationId = $("body").attr("event_id");

      $.ajax({
        type: "POST",
        url: "/ajax/organizer_booking_area_table/delete",
        data: {
          table_id: tableId,
          booking_area_table_id: bookingAreaTableId,
          location_id: locationId,
          delete_area: true,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("#booking-area-table-list-wrapper").empty();
            $("#booking-area-table-list-wrapper").append(data.html);
            popupAlert();
          }

          if (
            data.area_name !== undefined &&
            data.area_name !== null &&
            data.area_id !== undefined &&
            data.area_id !== null
          ) {
            if (
              !$(
                "select[name='booking_area_id'] option[value=" +
                  data.area_id +
                  "]",
              ).length
            ) {
              $("select[name='booking_area_id']").prepend(
                $("<option>", {
                  value: data.area_id,
                  text: data.area_name,
                }),
              );
            }
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
  }
});
